/**
 * /orders/:orderId
 *
 * A direct load renders the list behind the drawer, per DESIGN.md section 3, so a link
 * pasted into Slack lands on a working screen rather than a detail page with no context.
 * It is the same component as /orders with an order id, not a second screen, which is also
 * why the list state in the query string survives opening and closing the drawer.
 */
import { OrdersRoute } from './index';

export interface OrderDetailRouteProps {
  orderId: number;
  onOrderIdChange?: (orderId: number | null) => void;
}

export function OrderDetailRoute({ orderId, onOrderIdChange }: OrderDetailRouteProps) {
  return <OrdersRoute orderId={orderId} {...(onOrderIdChange ? { onOrderIdChange } : {})} />;
}

export default OrderDetailRoute;
